import styled from 'styled-components';
import {getToken} from '@tickchak/react-share/app';
import {dFlex, alignCenter} from '../../../../globalVariables/GlobalFlex';
    
export const container = styled.div`
    ${dFlex}
    ${alignCenter}
`;

export const staticText = styled.span`
    display: inline;
    white-space: pre-wrap;
    color: ${getToken('color.text.subtle')};
    cursor: default;
    user-select: none;
`;
